// L'état du panneau de notifications que chaque page branche sur sa
// coquille : la cloche l'ouvre et le referme. Aucune notification tant
// qu'elles ne sont pas branchées : un vrai cabinet ne doit pas lire des
// notifications fictives.

import { PanneauNotifications } from "@app/components/compta/coquille/PanneauNotifications";
import type { SectionDeNotifications } from "@app/types/compta/notifications";
import type { ReactNode } from "react";
import { useState } from "react";

interface PanneauxTransverses {
  panneau: ReactNode | undefined;
  nonLues: number;
  ouvrirNotifications: () => void;
  fermer: () => void;
}

export function usePanneauxTransverses(): PanneauxTransverses {
  const [ouvert, setOuvert] = useState(false);
  const [sections, setSections] = useState<SectionDeNotifications[]>([]);

  const nonLues = sections
    .flatMap((section) => section.notifications)
    .filter((notification) => notification.nonLue).length;

  const fermer = () => setOuvert(false);

  const panneau = ouvert ? (
    <PanneauNotifications
      sections={sections}
      onFermer={fermer}
      onToutMarquerLu={() =>
        setSections((etat) =>
          etat.map((section) => ({
            ...section,
            notifications: section.notifications.map((notification) => ({
              ...notification,
              nonLue: false,
            })),
          }))
        )
      }
    />
  ) : undefined;

  return {
    panneau,
    nonLues,
    ouvrirNotifications: () => setOuvert((etat) => !etat),
    fermer,
  };
}
